import {mapActions, mapState} from "vuex";

export const enterpriseSeries = {
    data() {
        return {
            formData: {
                id: null,
                name: "",
                tags: [],
                material: "",
                materialId: null,
                classTreeId: null,
                userId: null,
                // tenantDepartmentId: 0
            },
            imageUrl: "",
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur"],
                    },
                    {
                        pattern: /^[\s\S]{0,8}$/,
                        message: "不得超过8个文字",
                        trigger: ["blur", "change"],
                    },
                ],
                tag: [
                    {
                        pattern: /^[\s\S]{0,5}$/,
                        message: "不得超过5个文字",
                        trigger: ["blur", "change"],
                    },
                ],
                // userId: [
                //     {
                //         required: true,
                //         message: "请选择",
                //         trigger: ["blur"],
                //     },
                // ],
                // classTreeId: [
                //     {
                //         required: true,
                //         message: "请选择",
                //         trigger: ["blur"],
                //     },
                // ],
            },
        };
    },
    computed: {
        ...mapState("tenant", ["ossUploadObj"]),
    },
    methods: {
        ...mapActions("tenant", ["generalUploadUrl"]),
        ...mapActions("teachingCenter", ["saveClassSubject"]),
        async handleConfirm() {
            // this.formData.tenantDepartmentId = this.userInfo.tenantDepartmentId
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    await this.saveClassSubject({
                        ...this.formData,
                    });
                    if (this.formData.id) {
                        this.$message.success("编辑成功");
                    } else {
                        this.$message.success("添加成功");
                    }
                    await this.$router.push({name: "SeriesManagement"}, () => {
                    });
                }
            });
        },
        async handleConfirmAndContinue() {
            // this.formData.tenantDepartmentId = this.userInfo.tenantDepartmentId
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    await this.saveClassSubject({
                        ...this.formData,
                    });
                    if (this.formData.id) {
                        this.$message.success("编辑成功");
                    } else {
                        this.$message.success("添加成功");
                    }
                    this.formData.name = "";
                    this.formData.id = null;
                }
            });
        },
        async handleImgChange(file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            await this.generalUploadUrl({
                contentType: file.raw.type,
            });
            const fileName = encodeURIComponent(file.raw.name);
            this.formData.material = this.ossUploadObj.filename;
            const obj = {
                "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
                "Content-Type": file.raw.type,
            };
            this.$axios.defaults.withCredentials = false;
            await this.$axios({
                url: this.ossUploadObj.url,
                method: "put",
                isUpload: true,
                data: file.raw,
                headers: obj,
            })
                .then((res) => {
                    console.log(res);
                })
                .catch((e) => {
                    console.log(e);
                });
            this.$axios.defaults.withCredentials = true;
        },
        async handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上传封面图片只能是 JPG/PNG!");
            }
            if (!isLt2M) {
                this.$message.error("上传封面图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        clearForm() {
            Object.keys(this.formData).map((key) => {
                this.formData[key] = "";
            });
            this.formData.id = null;
            this.formData.classTreeId = null;
            this.formData.userId = null;
            this.formData.tags = [];
            // this.formData.tenantDepartmentId = 0
        },
    },
};
